<app-ion-page-content>
  <ion-refresher
    refresh
    slot="fixed"
    [disabled]="(currentPlatform$ | async) === platform.desktop"
    (ionRefresh)="onRefresh($event)"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <app-block>
    <app-common-shops-list [typeOfShopsPage]="shopsListTypes.allShops"></app-common-shops-list>
  </app-block>
</app-ion-page-content>
